(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceHeaderDeleteController',InvoiceHeaderDeleteController);

    InvoiceHeaderDeleteController.$inject = ['$uibModalInstance', 'entity', 'InvoiceHeader'];

    function InvoiceHeaderDeleteController($uibModalInstance, entity, InvoiceHeader) {
        var vm = this;

        vm.invoiceHeader = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InvoiceHeader.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
